import {CoreModel} from '../../model/CoreModel';
import {analyticsEvent} from '../../../../../viscomjs/analytics/analyticsEvent';
import {GotoNewState} from './GotoNewState';
import {longMonth} from '../../../helpers/FormatMonth';
import {GetAnalyticsStateName} from '../../../helpers/GetAnalyticsStateName';

const SwipeToNewState = doThat => {
    //
    return GotoNewState(doThat).then(doThat => {
        return new Promise(resolve => {
            if (!doThat) {
                resolve(doThat);
                return;
            }
            const model = CoreModel.instance();
            //
            // Analytics
            analyticsEvent(
                'Navigation',
                'scroll',
                `Scroll to: ${model.currentEventOpened ? longMonth(model.currentEventIndex) : GetAnalyticsStateName(model.state)}`
            );
            resolve(doThat);
        });
    });
};

export {SwipeToNewState};
